import { z } from 'zod';
import { STRING_FILTER_OPERATION, type StringFilter } from './operation.js';

export const stringValueSchema = z.string().nullable().optional();

export const stringFilterSchema = z.union([
    z.object({
        operation: z.enum([STRING_FILTER_OPERATION.inArray.id]),
        array: z.string().array(),
        includeBlanks: z.boolean().optional(),
    }),
    z.object({
        operation: z.enum([
            STRING_FILTER_OPERATION.equals.id,
            STRING_FILTER_OPERATION.doesNotEqual.id,
            STRING_FILTER_OPERATION.beginsWith.id,
            STRING_FILTER_OPERATION.endsWith.id,
            STRING_FILTER_OPERATION.containsLoose.id,
            STRING_FILTER_OPERATION.containsStrict.id,
            STRING_FILTER_OPERATION.doesNotContain.id,
        ]),
        value: z.string().nullable().optional(),
    }),
]);

export type StringFilterSchema = z.infer<typeof stringFilterSchema>;
export type StringFilterSchemaWithoutInArray = Exclude<
    StringFilterSchema,
    {
        operation: StringFilter['inArray']['id'];
    }
>;
